const envoieI18n = {
  "fr": {
    "hero": {
      "title": "Comment emballer ?",
      "desc": "Un colis soigné, trié et bien conditionné garantit l’arrivée de vos pièces en bon état. Un mauvais emballage peut faire chuter la conformité des écrans, provoquer des LCD cassés ou des nappes arrachées, et retarder votre paiement.",
      "alert": "Bordereau UPS : sous 24h après validation de votre panier, votre bordereau est généré dans votre espace client."
    },
    "intro": {
      "text": "Ci-dessous, un exemple type de colis soigné. Respecter ces étapes permet d’éviter les chocs, la casse liée au poids, et de garantir un traitement rapide par nos testeurs."
    },
    "steps": {
      "1": {
        "title": "Préparer le carton vide",
        "body": "Tapissez le fond du carton avec du papier bulle ou un matériau amortissant. Plus la base est stable, moins les chocs se transmettent aux écrans.",
        "alt": "Préparer le carton vide"
      },
      "2": {
        "title": "Trier & protéger chaque écran",
        "body": "Triez vos appareils, écrans par modèle/état et emballez-les un par un (papier bulle ou sachet de protection). Cela évite les frottements et les nappes arrachées.",
        "alt": "Trier & protéger chaque écran"
      },
      "3": {
        "title": "Organiser le carton (couches)",
        "body": "Placez les écrans pour occuper l’espace et limiter les mouvements. Ajoutez une couche de protection entre chaque étage.",
        "alt": "Organiser le carton (couches)",
        "note": "Comblez les vides avec du papier bulle ou du rembourrage."
      },
      "4": {
        "title": "Sceller & expédier",
        "body": "Fermez soigneusement le carton (ruban solide sur toutes les arêtes). Collez le bordereau UPS reçu dans votre espace client (généré sous 24 h).",
        "alt": "Sceller & expédier"
      }
    },
    "UPS": {
      "title": "Expédition avec UPS",
      "text": "Le bordereau est disponible sous 24 h dans votre espace client. Déposez ensuite le colis dans le réseau UPS indiqué."
    },
    "panels": {
      "checklist": {
        "title": "Checklist rapide",
        "i1": "Carton robuste + fond protégé",
        "i2": "Écrans triés par modèle/état",
        "i3": "Protection unitaire des écrans",
        "i4": "Couches séparées par protection",
        "i5": "Espaces vides comblés",
        "i6": "Carton bien scellé",
        "i7": "Bordereau UPS collé"
      },
      "avoid": {
        "title": "À éviter",
        "i1": "Écrans en vrac",
        "i2": "Carton trop grand",
        "i3": "Absence de rembourrage",
        "i4": "Mélanger fragiles et lourds"
      },
      "best": {
        "title": "Bonnes pratiques",
        "i1": "Orientation stable (à plat)",
        "i2": "Carton “à sa taille”",
        "i3": "Note avec références / n° envoi"
      }
    },
    "faq": {
      "title": "FAQ rapide",
      "q1": "Quand est généré mon bordereau ?",
      "a1": "Sous 24 h après validation, directement dans votre espace client.",
      "q2": "Quand suis-je payé ?",
      "a2": "Après réception et contrôle qualité de vos pièces.",
      "q3": "Que se passe-t-il si une pièce est cassée ?",
      "a3": "Elle est déclassée avec justificatif (photo/rapport).",
      "cta": "Préparer mon envoi"
    }
  },
  "en": {
    "hero": {
      "title": "How to pack?",
      "desc": "A neat, sorted and well-packed parcel ensures your parts arrive in good condition. Poor packaging can reduce screen compliance, cause broken LCDs or torn flex cables, and delay your payment.",
      "alert": "UPS label: within 24h after checkout, your label is generated in your account area."
    },
    "intro": {
      "text": "Below is a typical example of a neat parcel. Following these steps helps avoid shocks, weight-related breakage, and ensures fast processing by our testers."
    },
    "steps": {
      "1": {
        "title": "Prepare the empty box",
        "body": "Line the bottom of the box with bubble wrap or cushioning. The more stable the base, the less shocks are transmitted to the screens.",
        "alt": "Prepare the empty box"
      },
      "2": {
        "title": "Sort & protect each screen",
        "body": "Sort devices/screens by model/condition and wrap each one individually (bubble wrap or protective sleeve). This prevents rubbing and torn flex cables.",
        "alt": "Sort & protect each screen"
      },
      "3": {
        "title": "Organize the box (layers)",
        "body": "Place screens to fill space and limit movement. Add a protective layer between each level.",
        "alt": "Organize the box (layers)",
        "note": "Fill empty spaces with bubble wrap or padding."
      },
      "4": {
        "title": "Seal & ship",
        "body": "Carefully close the box (strong tape on all edges). Stick the UPS label received in your account (generated within 24h).",
        "alt": "Seal & ship"
      }
    },
    "UPS": {
      "title": "Shipping with UPS",
      "text": "The label is available within 24h in your account. Then drop the parcel at the indicated UPS location."
    },
    "panels": {
      "checklist": {
        "title": "Quick checklist",
        "i1": "Sturdy box + protected bottom",
        "i2": "Screens sorted by model/condition",
        "i3": "Individual screen protection",
        "i4": "Layers separated by protection",
        "i5": "Empty spaces filled",
        "i6": "Box well sealed",
        "i7": "UPS label attached"
      },
      "avoid": {
        "title": "To avoid",
        "i1": "Loose screens",
        "i2": "Box too large",
        "i3": "No padding",
        "i4": "Mixing fragile and heavy items"
      },
      "best": {
        "title": "Best practices",
        "i1": "Stable orientation (flat)",
        "i2": "Right-size the box",
        "i3": "Note with references / shipment no."
      }
    },
    "faq": {
      "title": "Quick FAQ",
      "q1": "When is my label generated?",
      "a1": "Within 24h after validation, directly in your account.",
      "q2": "When do I get paid?",
      "a2": "After receipt and quality check of your parts.",
      "q3": "What if a part is broken?",
      "a3": "It is downgraded with evidence (photo/report).",
      "cta": "Prepare my shipment"
    }
  },
  "pl": {
    "hero": {
      "title": "Jak pakować?",
      "desc": "Zadbana, posegregowana i dobrze zabezpieczona paczka gwarantuje, że części dotrą w dobrym stanie. Złe pakowanie może obniżyć zgodność ekranów, powodować pęknięcia LCD lub zerwane taśmy i opóźnić płatność.",
      "alert": "Etykieta UPS: w ciągu 24h od zatwierdzenia koszyka etykieta jest generowana w Twoim koncie."
    },
    "intro": {
      "text": "Poniżej typowy przykład zadbanej paczki. Przestrzeganie kroków pomaga uniknąć wstrząsów, uszkodzeń od ciężaru i gwarantuje szybkie przetwarzanie przez testerów."
    },
    "steps": {
      "1": {
        "title": "Przygotuj puste pudełko",
        "body": "Wyłóż dno pudełka folią bąbelkową lub wypełniaczem. Im stabilniejsza podstawa, tym mniej wstrząsy przenoszą się na ekrany.",
        "alt": "Przygotuj puste pudełko"
      },
      "2": {
        "title": "Sortuj i chroń każdy ekran",
        "body": "Posegreguj urządzenia/ekrany wg modelu/stanu i owijaj każdy osobno (folia bąbelkowa lub woreczek ochronny). Zapobiega to ocieraniu i zrywaniu taśm.",
        "alt": "Sortuj i chroń każdy ekran"
      },
      "3": {
        "title": "Organizacja pudełka (warstwy)",
        "body": "Ułóż ekrany tak, aby wypełnić przestrzeń i ograniczyć ruch. Dodaj warstwę ochronną między każdą kondygnacją.",
        "alt": "Organizacja pudełka (warstwy)",
        "note": "Wypełnij puste miejsca folią bąbelkową lub wypełniaczem."
      },
      "4": {
        "title": "Zapieczętuj i wyślij",
        "body": "Dokładnie zamknij pudełko (mocna taśma na wszystkich krawędziach). Przyklej etykietę UPS otrzymaną w koncie (generowana w 24h).",
        "alt": "Zapieczętuj i wyślij"
      }
    },
    "UPS": {
      "title": "Wysyłka UPS",
      "text": "Etykieta dostępna w ciągu 24h w Twoim koncie. Następnie nadaj paczkę w wskazanej sieci UPS."
    },
    "panels": {
      "checklist": {
        "title": "Szybka lista",
        "i1": "Solidne pudełko + zabezpieczone dno",
        "i2": "Ekrany posegregowane wg modelu/stanu",
        "i3": "Indywidualna ochrona ekranów",
        "i4": "Warstwy oddzielone ochroną",
        "i5": "Wypełnione puste przestrzenie",
        "i6": "Dobrze zaklejone pudełko",
        "i7": "Naklejona etykieta UPS"
      },
      "avoid": {
        "title": "Czego unikać",
        "i1": "Luźne ekrany",
        "i2": "Zbyt duże pudełko",
        "i3": "Brak wypełnienia",
        "i4": "Mieszanie kruchych z ciężkimi"
      },
      "best": {
        "title": "Dobre praktyki",
        "i1": "Stabilne ułożenie (na płasko)",
        "i2": "Pudełko dopasowane rozmiarem",
        "i3": "Notatka z referencjami / nr wysyłki"
      }
    },
    "faq": {
      "title": "Szybkie FAQ",
      "q1": "Kiedy generowana jest moja etykieta?",
      "a1": "W ciągu 24h od zatwierdzenia, bezpośrednio w Twoim koncie.",
      "q2": "Kiedy otrzymam płatność?",
      "a2": "Po odbiorze i kontroli jakości części.",
      "q3": "Co jeśli część jest uszkodzona?",
      "a3": "Zostaje zdegradowana z uzasadnieniem (zdjęcie/raport).",
      "cta": "Przygotuj moją wysyłkę"
    }
  },
  "es": {
    "hero": {
      "title": "¿Cómo embalar?",
      "desc": "Un paquete ordenado, clasificado y bien protegido garantiza que tus piezas lleguen en buen estado. Un mal embalaje puede reducir la conformidad de las pantallas, provocar LCD rotos o flex arrancados, y retrasar tu pago.",
      "alert": "Etiqueta UPS: en un máximo de 24 h después de validar tu cesta, la etiqueta se genera en tu área de cliente."
    },
    "intro": {
      "text": "A continuación, un ejemplo típico de un paquete bien preparado. Seguir estos pasos ayuda a evitar golpes, roturas por peso y garantiza un procesamiento rápido por parte de nuestros técnicos."
    },
    "steps": {
      "1": {
        "title": "Preparar la caja vacía",
        "body": "Forra el fondo de la caja con burbujas o material amortiguador. Cuanto más estable sea la base, menos se transmitirán los golpes a las pantallas.",
        "alt": "Preparar la caja vacía"
      },
      "2": {
        "title": "Clasificar y proteger cada pantalla",
        "body": "Clasifica tus dispositivos/pantallas por modelo/estado y envuelve cada uno individualmente (burbuja o funda protectora). Esto evita roces y flex arrancados.",
        "alt": "Clasificar y proteger cada pantalla"
      },
      "3": {
        "title": "Organizar la caja (capas)",
        "body": "Coloca las pantallas ocupando los espacios para limitar movimientos. Añade una capa de protección entre cada nivel.",
        "alt": "Organizar la caja (capas)",
        "note": "Rellena los huecos con burbujas o relleno."
      },
      "4": {
        "title": "Cerrar y enviar",
        "body": "Cierra bien la caja (cinta fuerte en todos los bordes). Pega la etiqueta UPS recibida en tu cuenta (generada en 24 h).",
        "alt": "Cerrar y enviar"
      }
    },
    "UPS": {
      "title": "Envío con UPS",
      "text": "La etiqueta está disponible en un máximo de 24 h en tu cuenta. Luego deposita el paquete en el punto UPS indicado."
    },
    "panels": {
      "checklist": {
        "title": "Checklist rápida",
        "i1": "Caja resistente + fondo protegido",
        "i2": "Pantallas clasificadas por modelo/estado",
        "i3": "Protección individual de cada pantalla",
        "i4": "Capas separadas con protección",
        "i5": "Huecos rellenados",
        "i6": "Caja bien sellada",
        "i7": "Etiqueta UPS pegada"
      },
      "avoid": {
        "title": "Evitar",
        "i1": "Pantallas sueltas",
        "i2": "Caja demasiado grande",
        "i3": "Falta de relleno",
        "i4": "Mezclar frágiles con pesados"
      },
      "best": {
        "title": "Buenas prácticas",
        "i1": "Orientación estable (en plano)",
        "i2": "Caja del tamaño adecuado",
        "i3": "Nota con referencias / nº de envío"
      }
    },
    "faq": {
      "title": "FAQ rápida",
      "q1": "¿Cuándo se genera mi etiqueta?",
      "a1": "En un máximo de 24 h tras validar, directamente en tu cuenta.",
      "q2": "¿Cuándo me pagan?",
      "a2": "Después de recibir y verificar la calidad de tus piezas.",
      "q3": "¿Qué pasa si una pieza está rota?",
      "a3": "Se degrada con justificante (foto/informe).",
      "cta": "Preparar mi envío"
    }
  },
  "it": {
    "hero": {
      "title": "Come preparare?",
      "desc": "Un pacco pulito, ordinato e ben confezionato assicura che le vostre parti arrivino in buone condizioni. Scarsa confezione può ridurre la conformità dello schermo, causare LCD rotti o cavi flex strappati, e ritardare il pagamento.",
      "alert": "Etichetta UPS: entro 24h dopo il checkout, la tua etichetta viene generata nell'area del tuo account."
    },
    "intro": {
      "text": "Qui di seguito è un tipico esempio di un pacco pulito. A seguito di questi passaggi aiuta a evitare urti, rottura del peso, e assicura un rapido trattamento dai nostri tester."
    },
    "steps": {
      "1": {
        "title": "Preparare la scatola vuota",
        "body": "Lineare il fondo della scatola con l'involucro di bolla o l'ammortizzazione. Più stabile la base, meno shock vengono trasmessi agli schermi.",
        "alt": "Preparare la scatola vuota"
      },
      "2": {
        "title": "Ordinare e proteggere ogni schermo",
        "body": "Ordinare dispositivi/schermi per modello/condizione e avvolgere ciascuno singolarmente (involucro di riempimento o manicotto protettivo). Questo impedisce lo sfregamento e lacerato cavi flex.",
        "alt": "Ordinare e proteggere ogni schermo"
      },
      "3": {
        "title": "Organizzare la scatola (strati)",
        "body": "Posizionare gli schermi per riempire lo spazio e limitare il movimento. Aggiungere uno strato protettivo tra ogni livello.",
        "alt": "Organizzare la scatola (strati)",
        "note": "Riempire spazi vuoti con fascia di bolla o imbottitura."
      },
      "4": {
        "title": "Sigillo e nave",
        "body": "Accuratamente chiudi la scatola (forte nastro su tutti i bordi). Inserisci l'etichetta UPS ricevuta nel tuo account (generata entro 24h).",
        "alt": "Sigillo e nave"
      }
    },
    "UPS": {
      "title": "Spedizione con UPS",
      "text": "L'etichetta è disponibile entro 24h sul tuo account. Quindi lasciare il pacco alla posizione indicata UPS."
    },
    "panels": {
      "checklist": {
        "title": "Elenco di controllo rapido",
        "i1": "Scatola robusta + fondo protetto",
        "i2": "Schermi ordinati per modello/condizione",
        "i3": "Protezione individuale dello schermo",
        "i4": "Livelli separati da protezione",
        "i5": "Spazi vuoti riempiti",
        "i6": "Scatola ben sigillata",
        "i7": "etichetta UPS allegato"
      },
      "avoid": {
        "title": "Per evitare",
        "i1": "Schermi lisci",
        "i2": "Scatola troppo grande",
        "i3": "Non imbottitura",
        "i4": "Mescolare oggetti fragili e pesanti"
      },
      "best": {
        "title": "Migliori pratiche",
        "i1": "orientamento stabile (flat)",
        "i2": "Taglia destra la scatola",
        "i3": "Nota con riferimenti / spedizione no."
      }
    },
    "faq": {
      "title": "Domande frequenti",
      "q1": "Quando viene generata la mia etichetta?",
      "a1": "Entro 24h dopo la convalida, direttamente nel tuo account.",
      "q2": "Quando mi pagano?",
      "a2": "Dopo il ricevimento e il controllo di qualità delle vostre parti.",
      "q3": "E se una parte fosse rotta?",
      "a3": "È degradato con le prove (foto / rapporto).",
      "cta": "Prepara la mia spedizione"
    }
  },
  "de": {
    "hero": {
      "title": "Wie zu packen?",
      "desc": "Ein ordentliches, sortiertes und gut verpacktes Paket sorgt dafür, dass Ihre Teile in gutem Zustand ankommen. Schlechte Verpackungen können die Bildschirmkonformität reduzieren, defekte LCDs oder zerrissene Flexkabel verursachen und Ihre Zahlung verzögern.",
      "alert": "UPS Label: Innerhalb von 24 Stunden nach dem Checkout wird Ihr Label in Ihrem Kontobereich generiert."
    },
    "intro": {
      "text": "Unten ist ein typisches Beispiel für ein ordentliches Paket. Das Befolgen dieser Schritte hilft, Erschütterungen und Gewichtsbrüche zu vermeiden und sorgt für eine schnelle Verarbeitung durch unsere Tester."
    },
    "steps": {
      "1": {
        "title": "Bereiten Sie die leere Box vor",
        "body": "Den Boden der Box mit Blasenwickel oder Dämpfung auskleiden. Je stabiler die Basis ist, desto weniger Stöße werden auf die Bildschirme übertragen.",
        "alt": "Bereiten Sie die leere Box vor"
      },
      "2": {
        "title": "Sortieren & Schützen Sie jeden Bildschirm",
        "body": "Sortieren Sie Geräte/Bildschirme nach Modell/Zustand und wickeln Sie jedes einzeln ein (Blasenwickel oder Schutzhülle). Dies verhindert das Reiben und Zerreißen von Flexkabeln.",
        "alt": "Sortieren & Schützen Sie jeden Bildschirm"
      },
      "3": {
        "title": "Organisieren Sie die Box (Layer)",
        "body": "Platzieren Sie Bildschirme, um Platz zu füllen und Bewegung zu begrenzen. Fügen Sie zwischen jedem Level eine Schutzschicht hinzu.",
        "alt": "Organisieren Sie die Box (Layer)",
        "note": "Füllen Sie leere Räume mit Blasenwickel oder Polsterung."
      },
      "4": {
        "title": "Robben und Schiffe",
        "body": "Schließen Sie die Box vorsichtig (starkes Klebeband an allen Rändern). Kleben Sie das UPS-Etikett, das Sie in Ihrem Konto erhalten haben (generiert innerhalb von 24h).",
        "alt": "Robben und Schiffe"
      }
    },
    "UPS": {
      "title": "Versand mit UPS",
      "text": "Das Label ist innerhalb von 24 Stunden in Ihrem Konto verfügbar. Dann lassen Sie das Paket an der angegebenen UPS-Position fallen."
    },
    "panels": {
      "checklist": {
        "title": "Schnelle Checkliste",
        "i1": "Stabile Box + geschützter Boden",
        "i2": "Bildschirme sortiert nach Modell/Zustand",
        "i3": "Individueller Bildschirmschutz",
        "i4": "Durch Schutz getrennte Schichten",
        "i5": "Leere Räume gefüllt",
        "i6": "Kasten gut versiegelt",
        "i7": "UPS-Etikett angebracht"
      },
      "avoid": {
        "title": "zu vermeiden",
        "i1": "Lose Bildschirme",
        "i2": "Kasten zu groß",
        "i3": "Keine Polsterung",
        "i4": "Mischung von zerbrechlichen und schweren Gegenständen"
      },
      "best": {
        "title": "Best Practices",
        "i1": "Stabile Ausrichtung (flach)",
        "i2": "Richtige Größe der Box",
        "i3": "Hinweis mit Referenzen / Sendungsnummer."
      }
    },
    "faq": {
      "title": "Schnelle FAQ",
      "q1": "Wann wird mein Label generiert?",
      "a1": "Innerhalb von 24 Stunden nach der Validierung direkt in Ihrem Konto.",
      "q2": "Wann werde ich bezahlt?",
      "a2": "Nach Erhalt und Qualitätsprüfung Ihrer Teile.",
      "q3": "Was ist, wenn ein Teil kaputt ist?",
      "a3": "Es wird mit Beweisen (Foto / Bericht) herabgestuft.",
      "cta": "Bereiten Sie meine Sendung vor"
    }
  },
  "pt": {
    "hero": {
      "title": "Como embalar?",
      "desc": "Um pacote puro, organizado e bem embalado garante que suas peças chegam em bom estado. A má embalagem pode reduzir a conformidade do ecrã, causar LCDs quebrados ou cabos flex rasgados, e atrasar o seu pagamento.",
      "alert": "Rótulo UPS: dentro de 24h após o checkout, seu rótulo é gerado na área de sua conta."
    },
    "intro": {
      "text": "Abaixo está um exemplo típico de um pacote puro. Seguir estes passos ajuda a evitar choques, ruptura relacionada ao peso e garante o processamento rápido pelos nossos testadores."
    },
    "steps": {
      "1": {
        "title": "Preparar a caixa vazia",
        "body": "Alinhe o fundo da caixa com plástico de bolha ou amortecimento. Quanto mais estável a base, menos choques são transmitidos para as ecrãs.",
        "alt": "Preparar a caixa vazia"
      },
      "2": {
        "title": "Ordenar e proteger cada ecrã",
        "body": "Ordenar dispositivos/ecrãs por modelo/condição e embrulhar cada um individualmente (embrulho bolha ou manga protetora). Isto evita esfregar e rasgar cabos flex.",
        "alt": "Ordenar e proteger cada ecrã"
      },
      "3": {
        "title": "Organize a caixa (camadas)",
        "body": "Coloque ecrãs para preencher espaço e limitar o movimento. Adicione uma camada protetora entre cada nível.",
        "alt": "Organize a caixa (camadas)",
        "note": "Preencha espaços vazios com invólucro de bolha ou enchimento."
      },
      "4": {
        "title": "Seal & navio",
        "body": "Feche cuidadosamente a caixa (fita forte em todas as bordas). Coloque o rótulo UPS recebido em sua conta (gerado dentro de 24h).",
        "alt": "Seal & navio"
      }
    },
    "UPS": {
      "title": "Envio com UPS",
      "text": "O rótulo está disponível nas 24h da sua conta. Em seguida, solte o pacote no local indicado UPS."
    },
    "panels": {
      "checklist": {
        "title": "Lista de verificação rápida",
        "i1": "Caixa robusta + fundo protegido",
        "i2": "Ecrãs ordenadas por modelo/condição",
        "i3": "Protecção individual do ecrã",
        "i4": "Camadas separadas por protecção",
        "i5": "Espaços vazios preenchidos",
        "i6": "Caixa bem selada",
        "i7": "Rótulo UPS anexado"
      },
      "avoid": {
        "title": "Para evitar",
        "i1": "Ecrãs soltas",
        "i2": "Caixa muito grande",
        "i3": "Sem enchimento",
        "i4": "Mistura de itens frágeis e pesados"
      },
      "best": {
        "title": "Boas práticas",
        "i1": "Orientação estável (plano)",
        "i2": "Tamanho direito da caixa",
        "i3": "Nota com referências / envio no."
      }
    },
    "faq": {
      "title": "FAQ Rápida",
      "q1": "Quando é gerado o meu rótulo?",
      "a1": "Dentro de 24h após a validação, diretamente em sua conta.",
      "q2": "Quando é que me pagam?",
      "a2": "Após o receção e verificação de qualidade de suas peças.",
      "q3": "E se uma parte estiver partida?",
      "a3": "É degradado com evidências (foto/relatório).",
      "cta": "Preparem o meu carregamento."
    }
  },
  "cs": {
    "hero": {
      "title": "Jak balit?",
      "desc": "Čistá, tříděná a dobře balená zásilka zajistí, že vaše díly dorazí v dobrém stavu. Špatný obal může snížit shodu obrazovky, způsobit rozbité LCD nebo roztrhané flex kabely, a odložit platbu.",
      "alert": "UPS štítek: do 24 hodin po checkout je váš štítek generován ve vašem účtu."
    },
    "intro": {
      "text": "Níže je typický příklad čistého balíku. Po těchto krocích pomáhá vyhnout se otřesům, poruše související s váhou a zajišťuje rychlé zpracování našimi testovateli."
    },
    "steps": {
      "1": {
        "title": "Připravte prázdnou krabici.",
        "body": "Spodní část krabice se nastaví bublinkovou fólií nebo polštářem. Čím stabilnější základna, tím méně šoků se přenáší na obrazovky.",
        "alt": "Připravte prázdnou krabici."
      },
      "2": {
        "title": "Třídit a chránit každou obrazovku",
        "body": "Třídit zařízení / obrazovky podle modelu / stavu a zabalit každý z nich jednotlivě (bublinkový obal nebo ochranný obal). To zabraňuje tření a roztržení ohybů kabelů.",
        "alt": "Třídit a chránit každou obrazovku"
      },
      "3": {
        "title": "Organizovat box (vrstvy)",
        "body": "Umístěte obrazovky pro vyplnění prostoru a omezení pohybu. Mezi každou úroveň přidejte ochrannou vrstvu.",
        "alt": "Organizovat box (vrstvy)",
        "note": "Vyplňte prázdné prostory bublinkovou fólií nebo vycpávkou."
      },
      "4": {
        "title": "Pečeť a loď",
        "body": "Pečlivě uzavřete krabici (silná páska na všech okrajích). Schovejte UPS štítek obdržený na vašem účtu (generovaný do 24h).",
        "alt": "Pečeť a loď"
      }
    },
    "UPS": {
      "title": "Přeprava s UPS",
      "text": "Štítek je k dispozici do 24 hodin na vašem účtu. Poté parcel zahoďte na místě UPS."
    },
    "panels": {
      "checklist": {
        "title": "Rychlý kontrolní seznam",
        "i1": "Pevná skříň + chráněný spodek",
        "i2": "Scény seřazené podle modelu / stavu",
        "i3": "Individuální ochrana obrazovky",
        "i4": "Vrstvy oddělené ochranou",
        "i5": "Prázdné prostory vyplněny",
        "i6": "Rámeček dobře zapečetěný",
        "i7": "Připojeno označení UPS"
      },
      "avoid": {
        "title": "Aby se zabránilo",
        "i1": "Volné obrazovky",
        "i2": "Krabice příliš velká",
        "i3": "Žádné vycpávky",
        "i4": "Míchání křehkých a těžkých předmětů"
      },
      "best": {
        "title": "Osvědčené postupy",
        "i1": "Stabilní orientace (plochá)",
        "i2": "Pravá velikost rámečku",
        "i3": "Poznámka s referencemi / číslo zásilky."
      }
    },
    "faq": {
      "title": "Rychlé FAQ",
      "q1": "Kdy bude moje vydavatelství vytvořeno?",
      "a1": "Do 24 hodin po potvrzení, přímo na vašem účtu.",
      "q2": "Kdy dostanu zaplaceno?",
      "a2": "Po obdržení a kontrole kvality Vašich dílů.",
      "q3": "Co když je část rozbitá?",
      "a3": "Je znehodnocena důkazy (foto / report).",
      "cta": "Připravte mi zásilku."
    }
  },
  "nl": {
    "hero": {
      "title": "Hoe te pakken?",
      "desc": "Een netjes, gesorteerd en goed verpakt pakket zorgt ervoor dat uw onderdelen in goede staat aankomen. Slechte verpakking kan de naleving van het scherm verminderen, defecte LCD's veroorzaken of gescheurde flexkabels, en uw betaling vertragen.",
      "alert": "UPS label: binnen 24 uur na de kassa wordt uw label gegenereerd in uw accountgebied."
    },
    "intro": {
      "text": "Hieronder is een typisch voorbeeld van een keurig pakket. Na deze stappen helpt schokken, gewichtsgerelateerde breuken te voorkomen en zorgt voor snelle verwerking door onze testers."
    },
    "steps": {
      "1": {
        "title": "Maak de lege doos klaar",
        "body": "Lijn de onderkant van de doos met bubble wrap of demping. Hoe stabieler de basis, hoe minder schokken worden overgebracht naar de schermen.",
        "alt": "Maak de lege doos klaar"
      },
      "2": {
        "title": "Elk scherm sorteren en beschermen",
        "body": "Sorteer de apparaten/schermen op model/conditioning en wikkel ze afzonderlijk in (belverpakking of beschermhuls). Dit voorkomt wrijven en gescheurde flexkabels.",
        "alt": "Elk scherm sorteren en beschermen"
      },
      "3": {
        "title": "Organiseer het vak (lagen)",
        "body": "Plaats schermen om ruimte te vullen en de beweging te beperken. Voeg een beschermlaag toe tussen elk niveau.",
        "alt": "Organiseer het vak (lagen)",
        "note": "Vul lege spaties met bubble wrap of padding."
      },
      "4": {
        "title": "Afdichten & schip",
        "body": "Sluit de doos voorzichtig (sterke tape aan alle randen). Plaats het UPS-label dat in uw account is ontvangen (gegenereerd binnen 24 uur).",
        "alt": "Afdichten & schip"
      }
    },
    "UPS": {
      "title": "Verzending met UPS",
      "text": "Het label is binnen 24 uur beschikbaar in uw account. Laat dan het pakket vallen op de aangegeven UPS-locatie."
    },
    "panels": {
      "checklist": {
        "title": "Snelle controlelijst",
        "i1": "Stevige doos + beschermde bodem",
        "i2": "Schermen gesorteerd op model/voorwaarde",
        "i3": "Individuele schermbeveiliging",
        "i4": "Lagen gescheiden door bescherming",
        "i5": "Lege spaties gevuld",
        "i6": "Doos goed verzegeld",
        "i7": "UPS label bevestigd"
      },
      "avoid": {
        "title": "Om te vermijden",
        "i1": "Losse schermen",
        "i2": "Doos te groot",
        "i3": "Geen opvulling",
        "i4": "Mengen van kwetsbare en zware voorwerpen"
      },
      "best": {
        "title": "Beste praktijken",
        "i1": "Stabiele oriëntatie (vlak)",
        "i2": "Rechter formaat van de doos",
        "i3": "Notitie met referenties / verzending nr."
      }
    },
    "faq": {
      "title": "Snelle FAQ",
      "q1": "Wanneer wordt mijn label gegenereerd?",
      "a1": "Binnen 24 uur na validatie, direct in uw account.",
      "q2": "Wanneer krijg ik betaald?",
      "a2": "Na ontvangst en kwaliteitscontrole van uw onderdelen.",
      "q3": "Wat als er een stuk gebroken is?",
      "a3": "Het wordt gedegradeerd met bewijsmateriaal (foto/rapport).",
      "cta": "Bereid mijn zending voor"
    }
  }
};

export default envoieI18n;
